import { useState, useEffect } from "react";
import juniortoes from "assets/img/juniortoes.jpg";// Update the path

const Popup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show popup after 3 seconds
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 12000);

    // Cleanup timeout
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <div
          className="fixed top-0 left-0 w-full h-full flex items-center justify-center blackcolor"
          style={{ zIndex: 9999, }}
        >
          <div className="relative w-8/12">
            {/* Close Icon */}
            <button
              onClick={handleClose}
              className="absolute top-2 right-0 mr-4 rounded-full text-black  text-xl font-bold z-10" style={{border:'2px solid #fff'}}
            >
             <i className="las la-times text-white font-bold p-2"/>
            </button>
            <img className="w-full h-auto" src={juniortoes} alt="Popup Image" />
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
